// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/jenkins_home/workspace/dz-pc-H5/src/models/employee';
import model_2 from '/var/jenkins_home/workspace/dz-pc-H5/src/models/order';
import model_3 from '/var/jenkins_home/workspace/dz-pc-H5/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'employee', model: model_1 },
model_2: { namespace: 'order', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
